import { gql } from '@apollo/client';
import { Dispatch } from '../components/architecture/frontend/index'
import { filter, withLatestFrom, map } from 'rxjs/operators'
import { merge } from 'rxjs'
import _ from 'lodash'

import mutations from './Helpers/mutations'

const MUTATE_UPSERT_SHIPMENT = gql`
  mutation upsertShipment(
      $shipment: ShipmentInput
    ){
      upsertShipment(
        shipment: $shipment
      ) {
        ...Data
      }
    }
    ${mutations.fragment}
`;

const GET_SHIPMENT = gql`
  query shipment($id: Int!) {
    shipment(id: $id) {
      ...Data
    }
  }
  ${mutations.fragment}
`;

const MUTATION_DENY_CLAIM = gql`
  mutation denyClaim($id: Int! $toAddress: String $message: String $replyTo: String) {
    denyClaim(id: $id toAddress: $toAddress message: $message replyTo: $replyTo) {
      ...Data
    }
  }
  ${mutations.fragment}
`;


merge(Dispatch.getAction('shipment.select'), Dispatch.getAction('shipment.load'))
  .pipe(
    // Filter new samples
    filter(e => !_.isNil(e))
  )
  .subscribe(e => Dispatch.nextAction('Request.shipment', { type: 'query', query: GET_SHIPMENT, variables: { id: e },  retry: process.env.REACT_APP_RETRY_INTERVAL }))

  merge(Dispatch.getAction('shipment.select'), Dispatch.getAction('shipment.load'))
  .pipe(
    // Filter new samples
    filter(e => !_.isNil(e))
  )
  .subscribe(e => Dispatch.nextState('shipment', 'loading'))

  merge(Dispatch.getAction('shipment.select'), Dispatch.getAction('shipment.load'))
  .pipe(
    // Filter new samples
    filter(e => _.isNil(e))
  )
  .subscribe(e => Dispatch.nextState('shipment', null))

Dispatch.getAction('shipment.save')
  .pipe(
    withLatestFrom(Dispatch.getState('shipment')),
    map(e => e[1]),
  )
  .subscribe(e => Dispatch.nextAction('Request.shipment', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))

const shipmentRequests$ = merge(
  Dispatch.getAction('Response.shipment'), 
  Dispatch.getAction('Response.denyClaim'), 
  Dispatch.getAction('Response.removePendingDenial'),
  Dispatch.getAction('Response.reopen'), 
  Dispatch.getAction('Response.toReferee'),
  Dispatch.getAction('Response.refereeUpload'),
  Dispatch.getAction('Response.removeRefereeUpload')
  )

shipmentRequests$
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.upsertShipment ?? e.data.shipment ?? e.data.uploadReferee?.[0] ?? e.data.denyClaim),
    map(e => ({
      ...e, 
      key: Math.random(), 
      sampleType: e.sampleType?.id, 
      ingredient: e.ingredient?.id, 
      customer: e.customer?.id, 
      origin: e.origin?.id, 
      status: e.status?.id,
      lab: e.lab?.id,
    })),
  )
  .subscribe(e => Dispatch.nextState('shipment', e))

//{type: 'sampleType', value: }
Dispatch.getAction('shipment.set')
  .pipe(
    filter(e => e.type !== 'sampleType')
  )
  .subscribe(e => Dispatch.nextState('shipment.' + e.type, e.value))

Dispatch.getAction('shipment.set')
  .pipe(
    filter(e => e.type === 'sampleType')
  )
  .subscribe(e => Dispatch.mergeState('shipment', {key: Math.random(), sampleType: e.value, ingredient: null, origin: null, customer: undefined}))

Dispatch.getAction('shipment.duplicate')
  .pipe(
    withLatestFrom(Dispatch.getState('shipment')),
    map(e => {
      const {id, ...newShipment} = e[1]
      return newShipment
    })
  )
  .subscribe(e => Dispatch.nextState('shipment', e))

  Dispatch.getAction('shipment.toReferee')
    .pipe(
      withLatestFrom(Dispatch.getState('shipment')),
      map(e => ({...e[1], refereeToSend: e[0] }))
    )
  .subscribe(e => Dispatch.nextAction('Request.toReferee', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))

   Dispatch.getAction('claim.deny')
    .pipe(
      withLatestFrom(Dispatch.getState('shipment')),
      map(e => ({...e[1], claimPendingDenial: true }))
    )
    .subscribe(e => Dispatch.nextAction('Request.denyClaim', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))
  
  Dispatch.getAction('claim.removePendingDenial')
    .pipe(
      withLatestFrom(Dispatch.getState('shipment')),
      map(e => ({...e[1], claimPendingDenial: false }))
    )
    .subscribe(e => Dispatch.nextAction('Request.removePendingDenial', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))
  
Dispatch.getAction('claim.reopen')
  .pipe(
    withLatestFrom(Dispatch.getState('shipment')),
    map(e => ({...e[1], claimDenied: false }))
  )
  .subscribe(e => Dispatch.nextAction('Request.reopen', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))

  shipmentRequests$
  .pipe(
    filter(e => !_.isNil(e.errors))
  )
  .subscribe(e => console.log(e.errors))

Dispatch.getAction('shipment.refereeUpload')

  .subscribe(e => Dispatch.nextAction('Request.refereeUpload', { type: 'mutation', query: mutations.UPLOAD_REFEREE, variables: {id: e.id, file: e.file } }))

Dispatch.getAction('shipment.refereeDownload')
  .subscribe(e => Dispatch.nextAction('Request.refereeDownload', { type: 'query', query: mutations.DOWNLOAD_REFEREE, variables: {id: e } }))

Dispatch.getAction('Response.refereeDownload')
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.refereeFileLink)
  )
  .subscribe(e => {
    window.open(e)
  })

Dispatch.getAction('shipment.removeRefereeUpload')
  .pipe(
    withLatestFrom(Dispatch.getState('shipment')),
      map(e => ({...e[1], refereeFile: null }))
  )
  .subscribe(e => Dispatch.nextAction('Request.removeRefereeUpload', { type: 'mutation', query: MUTATE_UPSERT_SHIPMENT, variables: { shipment: mutations.createShipmentInput(e) } }))